export const itemsPerPage = 25;
export const maxPageNumberForFullLoad = 50;
export const humanVerifiedHotelsPerPage = 3;
export const DEFAULT_LOCALE = 'en';
